module.exports = __webpack_public_path__ + "img/score-en.79a6bc07.png";